﻿
enum ShippingCarrierCodes {
    PP = 'PP'
}

interface ShippingPickupPointResult {
   shippingMethodId: number;   
   carrierDataJson: string;
}

export type ShippingPickupCallback = (resultElId: string, shippingMethodId: number, json: string) => void;

export class ShippingPickupPointSelector {
   private resultElId?: string;
   private shippingMethodId = 0;
   private resultCallback?: ShippingPickupCallback;

   private ppSelect(selectedAddress?: string): void {
      //let divPP = document.getElementById('ppWidgetId');
      //if (!divPP) {
      //    const elemDiv = document.createElement('div');
      //    elemDiv.id = 'ppWidgetId';
      //    document.body.appendChild(elemDiv);
      //    divPP = elemDiv;
      //    //'<div id="ppWidgetId" class="w-100" style="height: 500px"></div>'
      //}

      /*if (divPP)*/
      {
         const initAddr = (selectedAddress?.length ?? 0) > 0 ? selectedAddress : undefined;
         //alert('toggleMap: ' + JSON.stringify(initAddr));
         //@ts-ignore
         PPWidgetApp.toggleMap({
            callback: (data) => {               
               const result: ShippingPickupPointResult = {
                  shippingMethodId: this.shippingMethodId,
                  carrierDataJson: JSON.stringify(data)
               };
               const json = JSON.stringify(result);
               if (this.resultCallback) this.resultCallback(this.resultElId!, this.shippingMethodId, json);
               //const resultEl = document.getElementById(this.resultElId!) as HTMLInputElement;
               //if (resultEl) {
               //   resultEl.value = json;

               //   const inpEl = document.querySelector(`[data-bu-shid="${this.shippingMethodId}"]`);
               //   inpEl?.setAttribute('data-bu-pickup-valid', 'true');
               //}               
            },
            //elementId: 'ppWidgetId',
            address: initAddr
         });
      }
   }

   public select(
      resultElId: string,
      shippingMethodId: number,
      carrierCode: string,
      selectedAddress: string | undefined,
      callback: ShippingPickupCallback
   ): void {      
      if (carrierCode !== ShippingCarrierCodes.PP) return;

      this.resultElId = resultElId;
      this.shippingMethodId = shippingMethodId;
      this.resultCallback = callback;
      this.ppSelect(selectedAddress);
   }
}